import { useState, useEffect, useCallback } from 'react';

/**
 * Hook to manage the checkboxes column state
 * TODO: Deprecate this in favor of useCheckboxSelection
 * ---
 * @TODO need to re-implement custom hook, since it doesn't behave as expected with filtering/sorting
 * @param {*} param0.results all the rows of the table
 * @param {*} param0.featureFlag a feature flag to show the checkboxes column
 * @returns
 */
const useCheckboxColumn = ({ results, featureFlag }) => {
  const [checkboxList, setCheckboxList] = useState([]);

  const initAndfillArrayWith = useCallback(
    (value) => [...Array(results?.length).keys()].map(() => value),
    [results],
  );

  useEffect(() => {
    setCheckboxList(initAndfillArrayWith(false));
  }, [results, featureFlag, initAndfillArrayWith]);

  const handleSelectDeSelectAllRows = useCallback(
    (event) => {
      event.persist();
      const checked = event.target.checked;
      setCheckboxList(
        checked ? initAndfillArrayWith(true) : initAndfillArrayWith(false),
      );
    },
    [results, featureFlag, initAndfillArrayWith],
  );

  const handleSelectRow = useCallback(
    (index) => {
      setCheckboxList((prev) =>
        prev.map((value, i) => (i === index ? !value : value)),
      );
    },
    [results, featureFlag],
  );

  const isAtLeastOneRowSelected =
    checkboxList.filter((value) => value).length > 0;

  return {
    checkboxList,
    handleSelectDeSelectAllRows,
    handleSelectRow,
    isAtLeastOneRowSelected,
  };
};

export default useCheckboxColumn;
